"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PersonalPromoCodesHistoryListCtl = /** @class */ (function (_super) {
    __extends(PersonalPromoCodesHistoryListCtl, _super);
    function PersonalPromoCodesHistoryListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_id; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_admin_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.admin_id; });
        _this.dk_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.admin_login; });
        _this.dk_promo_code_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_id; });
        _this.dk_promo_code_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_message_to_player = UIUtils_1.UIUtils.IProp2Str(function (o) { o.message_to_player; });
        _this._errDialog = errDialog;
        return _this;
    }
    PersonalPromoCodesHistoryListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PersonalPromoCodesHistoryListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "promocode log with id [" + id + "] not found !";
    };
    PersonalPromoCodesHistoryListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListPersonalPromoCodeOfferCodesByCodeOfferIdGet.exec({
            personal_promocode_offer_id: data.personal_promocode_offer_id,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_title: resp.list[i].promo_code_text,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    admin_id: resp.list[i].admin_id,
                    admin_login: resp.list[i].admin_login,
                    message_to_player: resp.list[i].message_to_player
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PersonalPromoCodesHistoryListCtl;
}(BaseController_1.BaseController));
exports.PersonalPromoCodesHistoryListCtl = PersonalPromoCodesHistoryListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_personal/ctl/PersonalPromoCodesHistoryListCtl.ts
// module id = 1063
// module chunks = 0